import { inject, Injectable } from '@angular/core';
import { StorageService } from '@movilidad/app-core';

import { StopChoice, TripDirection } from './booking.model';

const MAX_RECENT = 5;

/** Paradas recientes por usuario y sentido, sólo en el dispositivo. */
@Injectable({ providedIn: 'root' })
export class RecentStops {
  private readonly storage = inject(StorageService);

  private key(userId: number | string): string {
    return `recent_stops_${userId}`;
  }

  async list(userId: number | string, direction: TripDirection): Promise<StopChoice[]> {
    const stored = await this.storage.get<StopChoice[]>(this.key(userId));
    return (Array.isArray(stored) ? stored : []).filter((stop) => stop.direction === direction).slice(0, MAX_RECENT);
  }

  async remember(userId: number | string, choice: StopChoice): Promise<void> {
    const stored = await this.storage.get<StopChoice[]>(this.key(userId));
    const others = (Array.isArray(stored) ? stored : []).filter(
      (stop) => stop.stopId !== choice.stopId || stop.direction !== choice.direction
    );
    await this.storage.set(this.key(userId), [choice, ...others].slice(0, MAX_RECENT * 2));
  }
}
